import { render, staticRenderFns } from "./VsContainer.vue?vue&type=template&id=2dc8c6a6&lang=pug&"
import script from "./VsContainer.vue?vue&type=script&lang=js&"
export * from "./VsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc8c6a6')) {
      api.createRecord('2dc8c6a6', component.options)
    } else {
      api.reload('2dc8c6a6', component.options)
    }
    module.hot.accept("./VsContainer.vue?vue&type=template&id=2dc8c6a6&lang=pug&", function () {
      api.rerender('2dc8c6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsContainer.vue"
export default component.exports